import React from "react";
import { useTheme } from "styled-components";
import VideoPlayerButtonComponent from "../../VideoPlayerButton";

const StillWatchingCloseIcon = ({
  showNextEpisodeCard,
  isSideNavOpen,
  showStillWatchingPrompt,
  altText,
  closeClickHandler,
}) => {
  const theme = useTheme();
  if (!showStillWatchingPrompt && !(showNextEpisodeCard && isSideNavOpen)) {
    return null;
  }

  return (
    <div className="binge-watch-close-icon">
      <VideoPlayerButtonComponent
        src={process.env.PUBLIC_URL + "/images/playback-close.svg"}
        alt={altText}
        onClickHandler={closeClickHandler}
        tooltipDirection="bottom"
        buttonClassName="playbackClose"
        $hoverBackgroundColor={theme.colours.mineShaftGray}
      />
    </div>
  );
};

export default StillWatchingCloseIcon;
